/** Etiqueta de alumno/grupo para corrección y ver corrección. */
import { formatPersonName, formatFullName } from './personName';

export function formatEntregaAlumno(entrega) {
  if (!entrega) return '-';

  if (entrega.entrega_en_grupos) {
    const grupo = entrega.grupo_nombre || entrega.alumno_nombre || 'Grupo';
    const alumnos = Array.isArray(entrega.alumnos) ? entrega.alumnos : [];
    if (alumnos.length > 0) {
      const nombres = alumnos
        .map((a) => a.nombre || formatFullName(a.first_name, a.last_name))
        .map((n) => formatPersonName(n) || n)
        .filter(Boolean)
        .join(', ');
      return nombres ? `${grupo} (${nombres})` : grupo;
    }
    return grupo;
  }

  return formatPersonName(entrega.alumno_nombre) || entrega.alumno_nombre || '-';
}
